var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.isOpened,"timeout":_vm.timeout,"color":"#049541","rounded":"lg","content-class":"justify-start"}},[_c('div',{staticClass:"d-flex align-center"},[_c('e-svg-icon',{staticClass:"mr-4"},[_vm._v(_vm._s(_vm.icon))]),_vm._v(_vm._s(_vm.text))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }